const skeletonBackgroundOpacity = 0.3;
const skeletonForegroundOpacity = 0.5;

export { skeletonBackgroundOpacity, skeletonForegroundOpacity };
